import {
  Accordion,
  Box,
  Button,
  Card,
  Container,
  Divider,
  Group,
  Loader,
  Menu,
  Modal,
  Paper,
  ScrollArea,
  Select,
  SimpleGrid,
  Stack,
  Text,
  Title,
  Tooltip,
  useMantineTheme,
  UnstyledButton,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import BenchBreadcrumbs from "./Components/BenchBreadcrumbs";
import {
  IconChevronDown,
  IconStar,
  IconHome,
  IconBell,
  IconCalendar,
  IconClockHour4,
  IconBarbell,
  IconChecklist,
  IconClock,
  IconRepeat,
  IconTreadmill,
  IconRun,
  IconInfoCircle,
  IconUser,
} from "@tabler/icons-react";

import BenchMiniCard from "./Components/BenchMiniCard";
import { useNavigate, useParams } from "react-router-dom";
import { logError } from "../ErrorLogService/ErrorLoggingService";
import {
  addDoc,
  arrayUnion,
  collection,
  collectionGroup,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
  writeBatch,
} from "firebase/firestore";
import { db } from "../../firebase/FirebaseCredential";
import { Carousel } from "@mantine/carousel";
import RoutineImg from "../../assets/RoutinImg.png";
import SlideComponent from "./Components/SliderComponent";
import BenchLoader from "./BenchLoader/BenchLoader";
import useBranchId from "../../hooks/useBranchId";
import { toast } from "react-toastify";
import { useAppSelector } from "../../hooks/hooks";
import { RootState } from "../../store/store";
import { useDisclosure } from "@mantine/hooks";
interface memberAddress {
  address_line1: string;
  address_line2: string;
  address_line3: string;
  city: string;
  country: string;
}
interface MemberData {
  // id:string ,
  first_name: string;
  last_name: string;
  mobile_number: any;
  address: memberAddress;
}
const Routinepage = () => {
  const { routineId } = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [routine, setRoutine] = useState<any>(null);
  const theme = useMantineTheme();
  const maincolor = theme.colors.brand[4];
  const navigate = useNavigate();
  const companyID = useAppSelector(
    (state: RootState) => state.session.company_id
  );
  const {
    branchesList,
    loading: branchLoading,
    error,
  } = useAppSelector((state) => state.branchList);

  // Accordion state
  const [activeItems, setActiveItems] = useState<string[]>([]);
  const [opened, { open, close }] = useDisclosure(false);
  const { branchId, setBranchId } = useBranchId(branchesList);
  const [branchName, setBranchName] = useState("");
  const [memberId, setMemberId] = useState<string | null>(null);
  const [memberData, setMemberData] = useState<MemberData | null>(null);
  const [memberList, setMemberList] = useState<any[]>([]);
  const [memberListLoader, setMemberListLoader] = useState<boolean>(false);
  const [targetDays, setTargetDays] = useState<string[]>([]);

  const handleOpenAssignModal = () => {
    const requiredDays = Number(routine?.num_of_workouts) || 0;
    switch (requiredDays) {
      case 3:
        setTargetDays(["Monday", "Wednesday", "Friday"]);
        break;
      case 4:
        setTargetDays(["Monday", "Tuesday", "Thursday", "Saturday"]);
        break;
      case 5:
        setTargetDays(["Monday", "Tuesday", "Wednesday", "Friday", "Saturday"]);
        break;
      case 6:
        setTargetDays([
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ]);
        break;
      default:
        setTargetDays([]);
        break;
    }
    open();
  };

  // Open first accordion when routine loads
  useEffect(() => {
    if (routine?.plan_details?.length) {
      setActiveItems([routine.plan_details[0].title]);
    }
  }, [routine]);

  // Fetch routine data
  const fetchRoutineData = async (routineId: string) => {
    setLoading(true);
    try {
      const routineDocRef = doc(db, "systemroutines", routineId);
      const routinedata = await getDoc(routineDocRef);
      if (routinedata.exists()) {
        setRoutine(routinedata.data());
        setLoading(false);
      } else {
        console.log("No such document!");
      }
    } catch (err) {
      logError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (routineId) fetchRoutineData(routineId);
  }, [routineId]);

  const totalExercises =
    routine?.plan_details.reduce((acc: number, item: any) => {
      const exercises = Array.isArray(item.exercises) ? item.exercises : [];
      return acc + exercises.length;
    }, 0) || 0;

  const carddata = [
    {
      details: [
        {
          label: routine?.level,
          subLabel: "Level",
          icon: IconStar,
          color: "#fff0f0",
          iconColor: "#ff6b6b",
        },
        {
          label: routine?.location,
          subLabel: "Location",
          icon: IconHome,
          color: "#e7f5ff",
          iconColor: "#4dabf7",
        },
        {
          label: routine?.num_of_workouts,
          subLabel: "Per Week",
          icon: IconCalendar,
          color: "#ebfbee",
          iconColor: "#51cf66",
        },
        {
          label: `${totalExercises} Exercises`,
          subLabel: "Total",
          icon: IconBell,
          color: "#f3f0ff",
          iconColor: "#9775fa",
        },
        {
          label: "20–35 Mins",
          subLabel: "Per Day",
          icon: IconClockHour4,
          color: "#fff4e6",
          iconColor: "#ffa94d",
        },
      ],
      overview:
        "This full-body strength routine is designed to build muscle and improve overall strength. It includes a variety of exercises targeting all major muscle groups, with a focus on compound movements. This routine is suitable for intermediate fitness levels and requires access to gym equipment.",
    },
  ];
  const carddatas = carddata[0];

  const breadcrumbLinks = [
    { label: "Routine", path: "/routineplan" },
    { label: "Routine Detail" },
  ];
  const handleExcercisePage = (exerciseId: string, routineId: any) => {
    navigate(`/exercise/${routineId}/${exerciseId}`);
  };
  const fetchMemberData = async () => {
    console.log(branchId);
    try {
      setMemberList([]);
      setMemberListLoader(true);
      const membersCollectionRef = collectionGroup(db, "members");
      const baseQuery = query(
        membersCollectionRef,
        where("company_id", "==", companyID),
        where("branch_id", "==", branchId),
        where("status", "==", "Active")
      );
      const memberSnapshot = await getDocs(baseQuery);

      if (memberSnapshot.empty) {
        setMemberList([]);
      } else {
        const members = memberSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...(doc.data() as MemberData),
        }));
        console.log(members);
        setMemberList(members);
      }
    } catch (error) {
      logError(error, "add invoice page");
    } finally {
      setMemberListLoader(false);
    }
  };
  console.log(branchId);
  useEffect(() => {
    if (branchId) {
      fetchMemberData();
    }
  }, [branchId]);

  const handleBranchSelect = (value: string) => {
    setBranchId(value);

    const SelectedData = branchesList?.find(
      (item: { id: string }) => item?.id === value
    );

    if (SelectedData) {
      setBranchName(SelectedData?.name ?? "");
    } else {
      setBranchName(""); // Optional: Handle cases where no matching branch is found
    }
  };
  const handleMemberSelect = (value: string | null) => {
    console.log(value);
    setMemberId(value);

    console.log(memberId);
    const SelectedData = memberList.find((item) => item.id === value);

    if (SelectedData) {
      setMemberData(SelectedData);
    } else {
      setMemberData(null); // Reset if no member is found
    }
  };

  // Helper to remove undefined values for Firestore safety
  const cleanForFirestore = (obj: any) => {
    const clean: any = {};
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== undefined) {
        clean[key] = obj[key];
      }
    });
    return clean;
  };

  // Optimized handleAssignRoutine
  const handleAssignRoutine = async () => {
    if (!branchId) return toast.warn("Please select a branch first");
    if (!memberId) return toast.warn("Please select a member to assign this routine");
    if (!routine) return toast.warn("Routine not found");

    try {
      setLoading(true);

      // 1. Direct Reference to Member
      const memberDocRef = doc(db, "branch", branchId, "members", memberId);
      const memberSnap = await getDoc(memberDocRef);

      if (!memberSnap.exists()) {
        toast.error("Member not found in this branch.");
        setLoading(false);
        return;
      }

      const memberData = memberSnap.data();
      const currentExercises = memberData.exercises_plan_id || [];

      // 2. Robust Duplicate Check
      const alreadyAssigned = currentExercises.some(
        (item: any) => (item.routine_id === routineId) || (item === routineId)
      );

      if (alreadyAssigned) {
        toast.warn(`Routine '${routine.goal || "this routine"}' is already assigned.`);
        setLoading(false);
        return;
      }

      if ((memberData as any)?.member_uid || (memberData as any)?.uid) {
        const requiredDays = Number(routine?.num_of_workouts) || 0;
        if (requiredDays > 0 && targetDays.length !== requiredDays) {
          toast.warn(`Please select exactly ${requiredDays} Target Days`);
          setLoading(false);
          return;
        }
      }

      const batch = writeBatch(db);

      // 3. Update Member Document
      batch.update(memberDocRef, {
        exercises_plan_id: arrayUnion({
          routine_id: routineId,
          routine_name: routine.goal || "Unnamed Routine",
          assigned_at: new Date(),
        }),
      });

      // 4. Atomic Sync with Fitness Profile (Mobile App)
      if (memberData?.uid) {
        const routinesCollectionRef = collection(db, "fitnessprofile", memberData.uid, "myworkoutplans");

        // Use routineId as the document reference for the workout plan
        const workoutPlanRef = doc(routinesCollectionRef, routineId);

        batch.set(workoutPlanRef, {
          company_id: (memberData as any).company_id || companyID || "",
          created_at: serverTimestamp(),
          branch_id: branchId,
          routine_id: routineId,
          routine_name: routine.goal || "",
          level: routine.level || "",
          location: routine.location || "",
          overview: routine.overview || "",
          number_of_workouts: routine.num_of_workouts || "",
          selected_days: targetDays || [],
        });

        // Sync Workouts
        const workoutsRef = collection(workoutPlanRef, "myworkouts");
        for (let idx = 0; idx < (routine.plan_details || []).length; idx++) {
          const workout = routine.plan_details[idx];
          if (workout) {
            const workoutSubDocRef = doc(workoutsRef);
            // Clean workout object to remove undefined values which crash Firestore batch.set
            const cleanedWorkout = cleanForFirestore(workout);
            batch.set(workoutSubDocRef, {
              ...cleanedWorkout,
              company_id: (memberData as any).company_id || companyID || "",
              branch_id: branchId,
              created_at: serverTimestamp(),
              assigned_day:
                targetDays && targetDays.length > 0
                  ? targetDays[idx % targetDays.length]
                  : "",
            });
          }
        }
      }

      // 5. Commit everything together
      await batch.commit();

      toast.success("Routine assigned successfully!");
      close();
    } catch (error: any) {
      console.error("Error assigning routine:", error);
      // Log more details to help debug the "assigned but show error toast" issue
      toast.error(`Failed to assign routine: ${error.message || "Unknown error"}`);
      logError(error, "handleAssignRoutine Routinepage");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size={"lg"}>
        <Box
                  sx={(theme) => ({
                    position: "sticky",
                    top: 110, // Avoid overlapping the fixed navbar
                    zIndex: 100,
                    backgroundColor: "#FAFAFA",
                    paddingTop: theme.spacing.sm,
                    //paddingBottom: theme.spacing.xs,
                    marginTop: `-${theme.spacing.sm}`,
                  })}
                >
      <SimpleGrid cols={2}>
        <BenchBreadcrumbs links={breadcrumbLinks} />
        <Group position="right">
          <Button onClick={handleOpenAssignModal}>Assign Member</Button>
          {/* <Menu shadow="md" width={180}>
            <Menu.Target>
              <Button
                variant="outline"
                rightIcon={<IconChevronDown size={16} />}
              >
                More Actions
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Action 1</Menu.Item>
              <Menu.Item>Action 2</Menu.Item>
              <Menu.Item>Action 3</Menu.Item>
            </Menu.Dropdown>
          </Menu> */}
        </Group>
      </SimpleGrid>

      <Divider my="sm" /></Box>
      <Title order={4} m="lg">
        Routine Plan Details
      </Title>

      <Card m="md">
        <Text color="dimmed" ml="md">
          Routine Name
        </Text>
        <Text color={maincolor} fw={"bold"} ml="md">
          {routine?.goal}
        </Text>
        <BenchMiniCard carddatas={carddatas} m="lg" />
        <Stack>
          <Title order={5} ml="md" mt="md">
            Overview
          </Title>
          <Text mx="md" mb="md" color="dimmed">
            {carddatas.overview}
          </Text>
        </Stack>
      </Card>

      <Accordion
        mb="xl"
        m="lg"
        multiple
        value={activeItems}
        onChange={setActiveItems}
        variant="filled"
      >
        {routine?.plan_details?.map((plan: any) => (
          <Accordion.Item key={plan.title} value={plan.title} my="xl">
            <Accordion.Control
              icon={<IconBarbell size={18} color="currentColor" />}
              my="md"
              sx={{
                fontWeight: 600,
                height: 40,
                padding: "0 16px",
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                border: `2px solid white`,
                color: maincolor,
                backgroundColor: "transparent",
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                "&:hover": {
                  backgroundColor: maincolor,
                  color: "white",
                },
                "[data-active] &": {
                  backgroundColor: maincolor,
                  color: "white",
                },
              }}
            >
              <Text fw={700}>{plan.title}</Text>
            </Accordion.Control>
            <Accordion.Panel >
              <Container>
                <SlideComponent visible={3} gap={16}>
                  {plan.exercises.map((exercise: any) => {
                    const metrics = exercise.metrics || {};
                    const setsArray = Array.isArray(metrics?.sets) ? metrics.sets : [];
                    const firstSet = setsArray[0] || {};

                    const safeValue = (val: any) =>
                      val === undefined ||
                        val === null ||
                        (typeof val === "object" && !Array.isArray(val) && Object.keys(val).length === 0)
                        ? "-"
                        : val;

                    const extractSum = (obj: any) => {
                      if (!obj) return "-";
                      if (typeof obj === "object" && !Array.isArray(obj)) {
                        const sum = Object.values(obj).reduce(
                          (total: number, val) => total + (Number(val) || 0),
                          0
                        );
                        return sum || "-";
                      }
                      return safeValue(obj);
                    };

                    const duration = extractSum(firstSet?.time || metrics?.time);
                    const reps = extractSum(firstSet?.reps || metrics?.reps);
                    const sets = setsArray.length > 0 ? setsArray.length : safeValue(metrics?.sets);
                    const distance = safeValue(firstSet?.distance_km || metrics?.distance_km);
                    const weight = safeValue(firstSet?.weight || metrics?.weight);

                    // Define all metric types except sets
                    const allMetrics = [
                      {
                        key: "time",
                        label: "s",
                        value: duration,
                        icon: <IconClock size={14} />,
                      },
                      {
                        key: "reps",
                        label: "Reps",
                        value: reps,
                        icon: <IconRepeat size={14} />,
                      },
                      {
                        key: "distance",
                        label: "km",
                        value: distance,
                        icon: <IconRun size={14} />,
                      },
                      {
                        key: "weight",
                        label: "kg",
                        value: weight,
                        icon: <IconBarbell size={14} />,
                      },
                    ];

                    // Filter valid ones (those having a real value)
                    const validMetrics = allMetrics.filter(
                      (m) => m.value !== "-"
                    );

                    // Always pick 2 metrics — fill with placeholders if needed
                    const metricsToDisplay =
                      validMetrics.length >= 2
                        ? validMetrics.slice(0, 2)
                        : [
                          ...validMetrics,
                          ...allMetrics
                            .filter((m) => !validMetrics.includes(m))
                            .slice(0, 2 - validMetrics.length),
                        ];

                    return (
                      <Card
                        key={exercise.exercise_id || exercise.name}
                        p="sm"
                        radius="md"
                        withBorder
                        sx={(theme) => ({
                          transition: "all 0.2s ease",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows.md,
                          },
                        })}
                      >
                        <Card.Section>
                          <img
                            src={exercise.media?.images?.[0] || RoutineImg}
                            alt={exercise.name || "Exercise"}
                            style={{
                              width: "100%",
                              height: 160,
                              objectFit: "cover",
                              borderRadius: 8,
                            }}
                          />
                        </Card.Section>

                        <Stack spacing={4} mt="sm" align="center">
                          <Text fw={600} size="sm" align="center" lineClamp={1}>
                            {exercise.name || "Unnamed Exercise"}
                          </Text>

                          {/* ✅ Always exactly 3 metrics (sets + 2 others) */}
                          <Group position="center" spacing="xs" my="sm">
                            {/* Always show sets */}
                            <Group spacing={4} align="center">
                              <IconChecklist size={14} />
                              <Text size="xs">
                                {sets !== "-" ? `${sets} Set` : "-"}
                              </Text>
                            </Group>

                            {/* Two other metrics */}
                            {metricsToDisplay.map((m) => (
                              <Group key={m.key} spacing={4} align="center">
                                {m.icon}
                                <Text size="xs">
                                  {m.value !== "-"
                                    ? `${m.value} ${m.label}`
                                    : "-"}
                                </Text>
                              </Group>
                            ))}
                          </Group>

                          {/* <Button
                            fullWidth
                            variant="outline"
                            color={maincolor}
                            size="xs"
                            styles={(theme) => ({
                              root: {
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  backgroundColor: maincolor,
                                  color: "white",
                                },
                              },
                            })}
                            onClick={() =>
                              handleExcercisePage(
                                exercise.exercise_id,
                                routineId
                              )
                            }
                          >
                            View Full Exercise
                          </Button> */}
                        </Stack>
                      </Card>
                    );
                  })}
                </SlideComponent>
              </Container>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>

      <BenchLoader isLoading={loading} />

      <Modal
        scrollAreaComponent={ScrollArea.Autosize}
        opened={opened}
        onClose={close}
        title={<Title order={4}>Assign Routine</Title>}
        closeButtonProps={{
          iconSize: "52",
        }}
      >
        <Stack>
          {/* Select Branch */}
          <Select
            label={
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <span>Select Branch</span>
                <Tooltip label="Choose the branch associated with this invoice. This is required for tracking transactions correctly.">
                  <IconInfoCircle
                    stroke={1}
                    size={16}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
              </div>
            }
            value={branchId || null}
            onChange={handleBranchSelect}
            data={branchesList
              .filter((item: any) => item.id !== "all_branches")
              .map((item: any) => ({
                value: item.id,
                label: item.name,
              }))}
            nothingFound
            placeholder="Select Branch"
            withAsterisk
            required
            withinPortal
          />

          {/* Select Member */}
          <Select
            clearable
            icon={<IconUser size="1rem" />}
            label={
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <span>Select Member</span>
                <Tooltip label="Select the customer or member for whom this invoice is being generated.">
                  <IconInfoCircle
                    stroke={1}
                    size={16}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
              </div>
            }
            value={memberId}
            onChange={(value) => handleMemberSelect(value)}
            data={memberList.map((item) => ({
              value: item.id,
              label: `${item.first_name} ${item.last_name || ""}`,
              memberID: item.member_uid,
            }))}
            maxDropdownHeight={300}
            searchable
            nothingFound={
              memberListLoader ? <Loader size="sm" /> : "No Member Found"
            }
            placeholder="Select Member"
            required
            withinPortal
          />

          {/* Target Days */}
          {((memberData as any)?.member_uid || (memberData as any)?.uid) && (
            <Box>
              <Text size="sm" weight={600} color="dimmed" mb="xs">
                <IconClock
                  size={14}
                  style={{ verticalAlign: "middle", marginRight: 4 }}
                />{" "}
                Target Days <span style={{ color: "#fa5252" }}>*</span>
              </Text>
              <Group spacing={8}>
                {[
                  { label: "M", value: "Monday" },
                  { label: "T", value: "Tuesday" },
                  { label: "W", value: "Wednesday" },
                  { label: "T", value: "Thursday" },
                  { label: "F", value: "Friday" },
                  { label: "S", value: "Saturday" },
                  { label: "S", value: "Sunday" },
                ].map((day, idx) => {
                  const isSelected = targetDays.includes(day.value);
                  return (
                    <UnstyledButton
                      key={`${day.value}-${idx}`}
                      onClick={() => {
                        if (isSelected) {
                          setTargetDays(
                            targetDays.filter((d) => d !== day.value)
                          );
                        } else {
                          const requiredDaysStr = routine?.num_of_workouts || routine?.number_of_workouts;
                          const requiredDays = Number(requiredDaysStr) || 0;
                          if (
                            requiredDays > 0 &&
                            targetDays.length >= requiredDays
                          ) {
                            toast.warn(
                              `You can only select exactly ${requiredDays} Target Days.`
                            );
                            return;
                          }
                          setTargetDays([...targetDays, day.value]);
                        }
                      }}
                      sx={(theme: any) => ({
                        width: 38,
                        height: 38,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 600,
                        fontSize: theme.fontSizes.sm,
                        color: isSelected ? theme.white : theme.colors.gray[6],
                        backgroundColor: isSelected
                          ? theme.colors.brand[4]
                          : theme.colors.gray[1],
                        border: `1px solid ${isSelected ? theme.colors.brand[4] : theme.colors.gray[3]}`,
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: isSelected
                            ? theme.colors.brand[5]
                            : theme.colors.gray[2],
                        },
                      })}
                    >
                      {day.label}
                    </UnstyledButton>
                  );
                })}
              </Group>
              <Text size="xs" color="dimmed" mt={4}>
                {routine?.location?.toLowerCase() === 'gym' 
                    ? "Remaining days are rest days or light workout days." 
                    : "Remaining days are rest days."}
              </Text>
            </Box>
          )}

          {/* Buttons */}
          <Group my="lg" align="center" position="center">
            <Button variant="outline" onClick={close}>
              Cancel
            </Button>
            <Button onClick={handleAssignRoutine}>Assign Routine</Button>
          </Group>
        </Stack>
      </Modal>
    </Container>
  );
};

export default Routinepage;
